export const initialState = {
  selectedAnalysis: { value: { columns: [], items: [] } },
  countries: [],
}

export default {
  namespaced: true,
  state: () => ({
    selectedAnalysis: { value: { columns: [], items: [] } },
    countries: [],
  }),
  mutations: {
    RESET_STATE_BUYERS(state) {
      Object.assign(state, initialState)
    },
    setCountries(state, countries) {
      state.countries = countries;
    },
    restoreState(state, newState) {
      Object.assign(state, newState);
    },
    setSelectedAnalysis(state, selectedAnalysis) {
      state.selectedAnalysis = selectedAnalysis;
    },
  },
  getters: {
    selectedAnalysis: state => {
      let emptyAnalysis = { value: { columns: [], items: [] } };
      return state.selectedAnalysis != null ? state.selectedAnalysis : emptyAnalysis;
    },
    countries: state => {
      return state.countries;
    },
  },
  actions: {
    reset(context) {
      context.commit('setSelectedAnalysis', { value: { columns: [], items: [] } });
    },
  },
};
